import React from "react";
import { Tabs, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { WEBHOOK_TYPES } from "constants/webhook";

const WebhookLogDetail = ({ logDetail }) => {
  const { t: translate } = useTranslation();
  if (!logDetail) {
    return (
      <div className="p-4 text-center text-muted">
        Chưa chọn log nào để xem chi tiết.
      </div>
    );
  }

  // Component render từng khối code multi-line chuẩn format
  const renderDetailBlock = (title, content) => (
    <div className="mb-3">
      <div className={"font-weight-bold text-dark mb-1"}>{title}</div>
      <div className="p-2 bg-light rounded border">
        <pre className={"m-0 font-monospace text-secondary"}>
          {content || translate("webhook.noData")}
        </pre>
      </div>
    </div>
  );

  const tabItems = [
    {
      key: "request",
      label: "Request",
      children: (
        <div>
          {/* Phương thức */}
          <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded border mb-3">
            <span className="font-weight-bold text-dark">
              {translate("webhook.method")}
            </span>
            <span className="font-weight-bold text-primary">
              {logDetail.request?.method || "N/A"}
            </span>
          </div>

          {/* Webhook Type */}
          {renderDetailBlock(translate("webhook.type"), translate(WEBHOOK_TYPES.find((type) => type.value === logDetail.webhookType)?.label) || "N/A")}

          {/* URL */}
          {renderDetailBlock(translate("webhook.link"), logDetail.request?.url)}

          {/* Headers */}
          {renderDetailBlock(
            translate("webhook.headers"),
            logDetail.request?.headers,
          )}

          {/* Body */}
          {renderDetailBlock(
            translate("webhook.body"),
            logDetail.request?.body,
          )}
        </div>
      ),
    },
    {
      key: "response",
      label: "Response",
      children: renderDetailBlock(
        translate("webhook.response"),
        logDetail.response,
      ),
    },
    {
      key: "error",
      label: "Lỗi",
      children: renderDetailBlock(
        translate("webhook.detailError"),
        logDetail.error,
      ),
    },
  ];

  return (
    <div className="w-100">
      {/* Header Info */}
      <div className="mb-3">
        <div className="d-flex align-items-center mb-1">
          <Tag color={logDetail.color} className="mr-2">
            {logDetail.statusText}
          </Tag>
        </div>

        {/* Req 10: <ID> | <Thời gian> | <Thời lượng> */}
        <div className="text-secondary">
          {translate("webhook.ID")}: {logDetail.id} | {translate("webhook.time")}:{" "}  {logDetail.createdAt} | {translate("webhook.duration")}:{" "}
          {logDetail.duration}
        </div>
      </div>

      {/* Req 8: Tabs không bị background xám */}
      <Tabs defaultActiveKey="request" items={tabItems} />
    </div>
  );
};

export default WebhookLogDetail;
